import { CSSTransition } from 'react-transition-group';
import {
  StyledLoader,
  StyledLoaderContainer,
  StyledTransitionContainer,
} from './styled';

export interface LoaderProps {
  active?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({
  active,
  children,
  ...props
}) => (
  <>
    <StyledTransitionContainer>
      <CSSTransition
        in={active}
        timeout={400}
        classNames="loader-container-transition"
        unmountOnExit>
        <StyledLoaderContainer>
          <StyledLoader>
            <div />
            <div />
            <div />
            <div />
          </StyledLoader>
        </StyledLoaderContainer>
      </CSSTransition>
    </StyledTransitionContainer>
    {children}
  </>
);
